<template>
  <div>
    <HardsubSubtitleWorkflow />
    <HardsubLanding />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();

// Canonical / hreflang / OG defaults come from useSeoHead() in app.vue; the
// page only sets its own title and description (same pattern as the other
// tool pages).
useHead({
  title: () => t("pages.hardsubToSubtitle.metaTitle"),
  meta: [{ name: "description", content: () => t("pages.hardsubToSubtitle.metaDescription") }],
});
</script>
